import { Ref, readonly, ref, watch } from 'vue';

interface GetBoundingClientRectPropertyRefsOptions {
  windowScroll: boolean;
  windowResize: boolean;
}

function getBoundingClientRectPropertyRefs(element: Ref<Element | undefined>, options?: Partial<GetBoundingClientRectPropertyRefsOptions>) {
  let resizeObserver: ResizeObserver | null = null;
  const height = ref(0);
  const bottom = ref(0);
  const left = ref(0);
  const right = ref(0);
  const top = ref(0);
  const width = ref(0);
  const x = ref(0);
  const y = ref(0);

  const update = () => {
    if (!element.value)
      return;

    const rect = element.value.getBoundingClientRect();

    height.value = rect.height;
    bottom.value = rect.bottom;
    left.value = rect.left;
    right.value = rect.right;
    top.value = rect.top;
    width.value = rect.width;
    x.value = rect.x;
    y.value = rect.y;
  }

  watch(element, newElement => {
    resizeObserver?.disconnect();

    if (newElement) {
      resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(newElement);
    } else {
      resizeObserver = null;
      update();
    }
  }, { immediate: true });

  if (options?.windowScroll)
    window.addEventListener('scroll', update, { capture: true, passive: true });
  if (options?.windowResize)
    window.addEventListener('resize', update, { passive: true });

  return {
    height: readonly(height),
    bottom: readonly(bottom),
    left: readonly(left),
    right: readonly(right),
    top: readonly(top),
    width: readonly(width),
    x: readonly(x),
    y: readonly(y),
    update
  };
}

export function useBoundingClientRect() {
  return {
    getBoundingClientRectPropertyRefs
  };
}
